import styled from "styled-components";

export const HeroBackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 600px; /* Use viewport height for responsive fullscreen first section */
  max-height: 700px; /* Limit maximum height */
  background-image: url('/img/bg.webp');
  background-size: cover;
  background-position: center top;
  z-index: -1;
  
  /* Add a gradient overlay to improve text readability */
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 70%, rgba(0,0,0,0) 100%);
  }

  /* Responsive breakpoints */
  @media only screen and (max-width: 992px) {
    max-height: 580px;
  }

  @media only screen and (max-width: 768px) {
    max-height: 500px;
  }

  @media only screen and (max-width: 576px) {
    max-height: 400px;
  }
`;